const ru = {
  i18n: {
    language: 'Русский',
    shortLang: 'Рус',
    locale: 'ru'
  },
  homeLogin: {
    chooseHowToSignIn: 'Выберите способ входа',
    tryTheGame: 'Попробуй игру',
    quickStart: 'Быстрый старт',
    signUp: 'Зарегистрироваться',
    signIn: 'Авторизоваться',
    back: 'Назад',
    submit: 'Отправить',
    logInWithEmail: 'Войти с электронной почты',
    signUpWithEmail: 'Зарегистрируйтесь по электронной почте',
    emailInputPlaceholder: 'Адрес электронной почты',
    passwordInputPlaceholder: 'Введите пароль',
    passwordConfirmInputPlaceholder: 'Повторите пароль',
    passwordSetNewInputPlaceholder: 'Введите новый пароль',
    keepMeLoggedIn: 'Запомнить меня',
    titleForgotPassword: 'Забыли пароль',
    passwordRecovery: 'Восстановление пароля',
    passwordRecoverySubtitle: 'Введите свой адрес электронной почты, и мы пришлем вам инструкции по восстановлению пароля.',
    rulesDescription: 'Я согласен с Условиями использования, я прочитал и понял Политику конфиденциальности.',
    emailError: 'Пожалуйста, укажите действующий адрес электронной почты.',
    passwordError: 'Пароль должен содержать не менее 8-32 символов',
    errorPasswordsDoesNotMatch: 'Введенные пароли не совпадают',
    emailSentTitle: 'Письмо отправлено',
    emailSentSubtitle: 'Если учетная запись существует, то на неё было отправлено электронное письмо с дальнейшими инструкциями.',
    orYouCan: 'или вы можете',
  },
  nav: {
    intro: 'Интро Незернайт',
    video: 'Что такое Незернайт?',
    game_modes: 'Игровые Режимы',
    leaderboard: 'Лидерборд',
    play_now: 'Играть Уже!'
  },
  homeHeader: {
    title: {
      first: 'Добро пожаловать в',
      second: 'Мир Незернайт'
    },
    promoText: 'Вступай в эпичные сражения уникальных Монстров!<br /> Расширяй армию и увеличивай силу своих воинов, в игре тебя ждет бесчисленное множество достижений и наград!',
    promoCaption: 'ПОШАГОВОЙ РОЛЕВОЙ БАТЛ ИГРЕ',
    buttonPlay: 'Играть уже!',
    additionally: {
      first: 'Играй в туториал и получи Монстра после первой битвы.'
    },
    bottomCaption: 'Исследуй мир',
    bottomDown: 'Листай вниз'
  },
  slides: {
    monsters: {
      title: 'Монстры',
      subtitle: 'Only the bravest one dare to challenge',
      description: 'Десятки легендарных героев ждут твоей команды!',
      footer_title: 'Незернайт Вики',
      footer_description: 'Описание эволюции скрыто на страницах NetherniteWiki.<br /> Изучи особенности Монстров и узнай кого еще можно встретить в мире Nethernite.<br/> Знание фракций и способностей существ помогут добиться успеха в игре!',
      type_name: 'Монстры',
      type_name_descr: 'Собери их всех'
    },
    arena: {
      title: 'Арена',
      subtitle: 'Only the bravest one dare to challenge',
      description: 'Создай свою легендарную команду монстров чтобы победить!',
      footer_title: 'СОЗДАЙ СВОЮ МЕТА-КОМАНДУ!',
      footer_description: 'Используй хитрую тактику и стратегию на поле боя. Сражайся с могущественными боссами и другими игроками, получай награды и опыт!',
      type_name: 'Арена',
      type_name_descr: 'Сражайся и побеждай'
    },
    altar: {
      title: 'Боссы',
      subtitle: 'Only the bravest one dare to challenge',
      description: 'Сражайся и побеждай могущественных Монстров!',
      footer_title: 'Уровни сложности',
      footer_description: 'На новых уровнях Босс становится сильнее, награды - лучше, а условия входа - сложнее. <br /> Только самые смелые осмелятся бросить вызов!',
      type_name: 'Боссы',
      type_name_descr: 'Борись за сокровища'
    },
    leaderboard: {
      title: 'Подземелье Душ',
      subtitle: 'Only the bravest one dare to challenge',
      description: 'Спустись в таинственное подземелье Nethernite!',
      footer_title: 'Types of monsters rarity',
      footer_description: 'Здесь ты встретишь Блуждающего Торговца с редкими и уникальными товарами.<br/>Попробуй зачистить подземелье с помощью пятерки лучших своих монстров, сразись за сокровища бессмертных призраков!<br/> Как далеко ты зайдешь?',
      type_name: 'Подземелье Душ',
      type_name_descr: 'Fight for treasures',
      btn_text: 'Go down!',
    },
    // altar: {
    //   title: 'Алтарь',
    //   description: 'Ты можешь получать души ненужных монстров, просто распыляя их в прах. Создавай случайных монстров из ресурса Прах Души. Скрещивай одинаковых монстров, переходя на следующий уровень редкости.',
    //   footer_title: 'Виды редкости монстров',
    //   footer_description: 'В Алтаре можно скрафтить или прокачать монстров до любого вида редкости - Базовый, Обычный, Необычный и Редкий!',
    //   type_name: 'Алтарь',
    //   type_name_descr: 'Улучшай монстров'
    // },
    // marketplace: {
    //   title: 'Торговая Площадка',
    //   description: 'Глобальный рынок Незернайт с собственной валютой, предназначенной для покупки и продажи монстров. Используйте его, чтобы наполнить свою команду еще более сильными персонажами!',
    //   footer_title: 'СИСТЕМА ТРЕЙДА',
    //   footer_description: 'Торгуйся картами монстров со своими друзьями или другими обитателями вселенной Незернайт, чтобы пополнить свою коллекцию.',
    //   type_name: 'Торговая Площадка',
    //   type_name_descr: 'Покупай и продавай'
    // },
    modes_leaderboard: {
      title: 'Лидерборд Незернайт',
      description: 'Сезоны Битв Незернайт с настоящим рейтингом, наградами и лигами. Поднимай свой рейтинг и попадай в новые лиги, доказывая что ты лучший!',
      footer_title: 'Лиги',
      footer_description: 'В зависимости от рейтинга игроки распределяются по лигам - Бронзовая, Серебряная, Золотая. Чем выше лига - тем выше награды и сложнее соперники!',
      type_name: 'Сезонный Рейтинг',
      type_name_descr: 'Поле Битвы'
    },
    modes_achievements: {
      title: 'Сезонные Достижения',
      description: 'В лидерборде есть Сезонные Достижения по различным дисциплинам, за которые даются награды для топовых игроков. Становись лучшим и получай редкие награды!',
      footer_title: 'Награды лучшим игрокам',
      footer_description: 'Одолей как можно больше боссов и монстров, больше всех нанеси урона и получи опыта, заработай максимально много монет и побеждай чаще других в ранговых боях. Получай щедрые награды за эти зачеты!',
      type_name: 'Сезонные Достижения',
      type_name_descr: 'Поле Битвы'
    }
  },
  play_now: {
    play_now: 'Играй уже и получи',
    pet_name: 'КОРОЛЕВСКИЙ ГРИФОН!',
    description: 'Играй в туториал и получи Монстра после первой битвы.'
  },
  video: {
    title: 'Начни свое путешествие к славе Nethernite!',
    descr: 'Откройте для себя удивительный мир, в котором обитают необычные Монстры.<br /> Собери своих героев, создай непобедимую команду, вступай в сражения с могущественными боссами и другими игроками!<br />Станешь ли ты лучшим из лучших со своей уникальной коллекцией Nethernite монстров?',
  },
  footer: {
    sitemap: 'Карта сайта',
    contactUs: 'Обратная связь',
    privacyAndCookies: 'Приватность и cookies',
    pp: 'Политика конфиденциальности',
    cp: 'Политика файлов cookie',
    ToS: 'Пользовательское соглашение',
    api: 'API',
    copyright: 'Nethernite© 2019',
    join_us: 'Присоединяйся к НАМ в Социальных Сетях'
  },
};

export default ru
